import StatamicObject from "./statamicObject"

export default class Poi extends StatamicObject {
  constructor(data) {
    super(data)
    Object.assign(this, data)

    this.openingHours = data.openingHours || []

    // format opening hours in a more usable way
    this.openingHoursByDay = this.openingHours.reduce(
      (acc, opening) => {
        const days = opening.days.map(day => day.value)

        days.forEach(day => {
          acc[day] = opening.periods
        })

        return acc
      },
      {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
      }
    )
  }

  hasGeoPosition() {
    return this.displayOnMap
  }

  hasOpeningHours() {
    return Array.isArray(this.openingHours) && this.openingHours.length > 1
  }

  hasProfiles() {
    return Array.isArray(this.profiles) && this.profiles.length > 1
  }

  getAddressLines() {
    const lines = []

    if (this.street) {
      lines.push(this.street)
    }

    if (this.zipCode && this.city) {
      lines.push(`${this.zipCode} ${this.city}`)
    } else if (this.city) {
      lines.push(this.city)
    }

    if (lines.length > 0 && this.country) {
      // it makes no sense to have the country alone
      lines.push(this.country)
    }

    return lines
  }

  /**
   * returns the corresponding opening hours for this day
   *
   * if the day has no periods, then it is considered as closed and will return
   * an empty array []
   */
  getTodayOpeningHours() {
    const days = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ]
    const dayNumber = new Date().getDay()
    const today = days[dayNumber]

    return this.openingHoursByDay[today] || []
  }

  getTeaserExcerpt() {
    if (this.teaserExcerpt) {
      return this.teaserExcerpt
    }

    const lines = this.getAddressLines()

    if (lines.length === 0) {
      return null
    }

    return this.getAddressLines()[0] + "<br/>" + this.getAddressLines()[1]
  }

  static formatOpeningHours(hours) {
    if (!hours || hours.length === 0) {
      return false
    }

    return hours.map(hour => `${hour.from}-${hour.to}`).join(", ")
  }
}
